<div class="softphone-dialpad">
  <div class="dialpad-history">{{ dialpadHistory }}&nbsp;</div>
  <div class="digits">
    <button *ngFor="let button of buttons; last as lastButton" class="digit" mat-flat-button (click)="handleDigit(button.value)">
      <span class="label">{{ button.label }}</span>
      <span class="sublabel" *ngIf="button.sublabel !== null">{{ button.sublabel || '&nbsp;' }}</span>
    </button>
  </div>
</div>
